import React, { useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../CustomButton";
import {
  trackButtonClickEvent,
  trackLinkClickEvent,
} from "../../utils/tracking";
import { useSnackbarContext } from "../../context/SnackbarContext";
import { customColors } from "../../theme";
import { useMediaQuery } from "@mui/material";
import { useNewsletterMutation } from "src/hooks/newsletter/useNewsletterMutation";

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { subscribe, isSubscriptionPending } = useNewsletterMutation();
  const { showSnackbar } = useSnackbarContext();
  const [email, setEmail] = useState("");

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleNewsletterSubmit = () => {
    trackButtonClickEvent({ label: "Newsletter subscription" });

    if (!validateEmail(email)) {
      showSnackbar({
        message: t("TEXT.AUTH.INVALID_EMAIL"),
        color: "error",
      });
      return;
    }

    subscribe({ email });
    setEmail("");
  };

  const links = (
    <div
      style={{
        flex: 1,
        margin: isMobile ? "20px " : "0 20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          letterSpacing: "8px",
          marginBottom: "40px",
          fontSize: "18px",
        }}
      >
        {t("FOOTER.LINKS").toUpperCase()}
      </h3>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        <li style={{ marginBottom: "15px" }}>
          <a
            href="/terms-of-service"
            style={{ color: customColors.white, textDecoration: "none" }}
            onClick={() =>
              trackLinkClickEvent({
                linkName: "Terms of Service",
                url: "/terms-of-service",
              })
            }
          >
            {t("FOOTER.TERMS")}
          </a>
        </li>
        <li style={{ marginBottom: "15px" }}>
          <a
            href="/privacy-policy"
            style={{ color: customColors.white, textDecoration: "none" }}
            onClick={() =>
              trackLinkClickEvent({
                linkName: "Privacy Policy",
                url: "/privacy-policy",
              })
            }
          >
            {t("FOOTER.PRIVACY")}
          </a>
        </li>
        <li>
          <a
            href="/privacy-policy"
            style={{ color: customColors.white, textDecoration: "none" }}
            onClick={() =>
              trackLinkClickEvent({
                linkName: "Cookie Policy",
                url: "/cookie-policy",
              })
            }
          >
            {t("FOOTER.COOKIE")}
          </a>
        </li>
      </ul>
    </div>
  );

  const newsletter = (
    <div
      style={{
        flex: 1,
        margin: "0 20px",
        textAlign: "center",
      }}
    >
      <h3
        style={{
          letterSpacing: "8px",
          marginBottom: "40px",
          fontSize: "18px",
        }}
      >
        {t("FOOTER.NEWSLETTER.LABEL")}
      </h3>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleNewsletterSubmit();
        }}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <input
          type="email"
          placeholder="Your Email Address"
          style={{
            maxWidth: isMobile ? "100%" : "315px",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            marginBottom: "16px",
          }}
          value={email}
          onChange={handleInputChange}
        />
        <CustomButton
          text={t("FOOTER.SUBSCRIBE_NOW")}
          onClick={handleNewsletterSubmit}
          isLoading={isSubscriptionPending}
          sx={{
            width: "170px",
          }}
        />
      </form>
    </div>
  );

  const address = (
    <div style={{ flex: 1, margin: "0 20px", textAlign: "center" }}>
      <h3
        style={{
          letterSpacing: "8px",
          marginBottom: "40px",
          fontSize: "18px",
        }}
      >
        {t("FOOTER.CONTACT").toUpperCase()}
      </h3>
      <p style={{ margin: 0, lineHeight: 1.8 }}>
        Feel free to reach out!
        <br />
        <b>contact@virtualstagingpro.ai</b>
      </p>
      <div style={{ marginTop: "15px" }}>
        <a
          href="https://www.instagram.com/virtualstaging.pro?igsh=bG94eGtocXlxbA=="
          style={{
            color: customColors.white,
            fontSize: "20px",
            textDecoration: "none",
          }}
        >
          <i className="fab fa-instagram"></i>
        </a>
      </div>
    </div>
  );

  return (
    <footer
      style={{
        background: customColors.darkGray,
        color: customColors.white,
        display: "flex",
        justifyContent: "space-around",
        padding: isMobile ? "0px" : "40px",
        textAlign: "center",
        flexWrap: "wrap",
        flexDirection: isMobile ? "column" : "row",
      }}
    >
      {isMobile ? (
        <>
          {newsletter}
          {links}
        </>
      ) : (
        <>
          {links} {newsletter}
        </>
      )}

      {address}
    </footer>
  );
};
